import { Paths } from "../constants/UrlConstants";
import { ButtonConfig, InboxPages } from "../constants/Constants";

const AskAMedicalExpertSmartLink = {
  linkText: "Ask a medical question",
  pathTo: `${Paths.MessageCentre}?page=${InboxPages.AskAMedicalExpertPage}`,
  iconName: "icon-health-plaster-crutch",
  id: ButtonConfig.AskAMedQuestion
};

export default AskAMedicalExpertSmartLink;
